import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.reduce";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Allows to do this:
 *
 * StyleSheet.create(bindObject({
 *   $color: 'red',
 *   app: (self) => ({
 *     color: self.$color,
 *   }),
 * }));
 */
export function bindObject(object) {
  return Object.entries(object).reduce(function (memo, entry) {
    var _entry = _slicedToArray(entry, 2),
        key = _entry[0],
        value = _entry[1];

    if (key.startsWith('$')) {
      return memo;
    }

    return _objectSpread({}, memo, _defineProperty({}, key, typeof value === 'function' ? value(object) : value));
  }, {});
}
/**
 * Allows to do this:
 *
 * StyleSheet.create(bindVars({
 *   $color: 'red',
 *   app: {
 *     color: '$color',
 *   },
 * }));
 */

export function bindVars(object, root) {
  root = root ? root : object;
  return Object.entries(object).reduce(function (memo, entry) {
    var _entry2 = _slicedToArray(entry, 2),
        key = _entry2[0],
        value = _entry2[1];

    if (key.startsWith('$')) {
      return memo;
    }

    if (typeof value !== 'string') {
      return _objectSpread({}, memo, _defineProperty({}, key, bindVars(value, root)));
    }

    var matches = value.match(/(\$\w+)/g);

    if (matches == null) {
      return _objectSpread({}, memo, _defineProperty({}, key, value));
    }

    return _objectSpread({}, memo, _defineProperty({}, key, matches.reduce(function (value, match) {
      return value.replace(match, root[match]);
    }, value)));
  }, {});
}